/* tslint:disable */
/* eslint-disable */

export var getIconColor = function getIconColor(color, index, defaultColor) {
  return color ? typeof color === 'string' ? color : color[index] || defaultColor : defaultColor;
};